import { trackToBugsnagApiError, log, LOG_LEVELS } from '@common/config/app_logger';
import { getFeesApi } from '@common/api/api';
import Const from '../config/const';
import { calculateDiffHandler, calculateRequiredFunds, getMinPrice } from '../../common/config/utils';
import { purchaseDetailsTypes, topupFlows } from '../../common/config/const';

export const changingPaymentSource = (changing) => (dispatch) => {
  dispatch({ type: Const.purchaseDetails.changingPaymentSource, changing });
};

export const doneChangingPaymentSource = () => (dispatch) => dispatch(changingPaymentSource(false));

export const updatePurchaseDetails = ({
  clickSource, purchaseType, topupFlow, details, successCallback
}) => (dispatch, getState) => {
  log(LOG_LEVELS.DEBUG, 'purchase_details', 'updatePurchaseDetails', {
    clickSource, purchaseType, topupFlow
  });
  const { user: { clientAvailableCredit, wallet26 } } = getState().user;
  const { price, isPayg } = details;
  const diffPrice = calculateDiffHandler({
    purchaseType, price, clientAvailableCredit
  });
  log(LOG_LEVELS.DEBUG, 'purchase_details', 'diffPrice', { diffPrice });

  const isMinPurchase = (diffPrice < getMinPrice() && !isPayg && (!topupFlow || topupFlow === topupFlows.regular) && ![purchaseDetailsTypes.AFFILIATE_PROMO_POPUP, purchaseDetailsTypes.ADVISOR_BONUS].includes(purchaseType));
  const requiredCredit = calculateRequiredFunds({ diffPrice, purchaseType, topupFlow });
  log(LOG_LEVELS.DEBUG, 'purchase_details', 'requiredCredit', { requiredCredit });

  if (wallet26) {
    dispatch({
      type: Const.purchaseDetails.updateDetails,
      purchaseType,
      clickSource,
      topupFlow,
      details: {
        ...details,
        diffPrice,
        isMinPurchase,
        requiredCredit,
        fees: {}
      }
    });

    successCallback?.();
    return;
  }

  getFeesApi({ amountToPay: requiredCredit }).then((fees) => {
    log(LOG_LEVELS.DEBUG, 'purchase_details', 'fees', { fees });
    dispatch({
      type: Const.purchaseDetails.updateDetails,
      purchaseType,
      clickSource,
      topupFlow,
      details: {
        ...details,
        diffPrice,
        isMinPurchase,
        requiredCredit,
        fees
      }
    });

    successCallback?.();
  }).catch((error) => {
    trackToBugsnagApiError('Error updatePurchaseDetails', error);
  });
};

export const updatePurchaseDetailsClickSource = (clickSource) => (dispatch) => {
  dispatch({ type: Const.purchaseDetails.updateClickSource, clickSource });
};
export const clearPurchaseDetails = () => ({
  type: Const.purchaseDetails.clearDetails
});

export const checkIfCanMakeApplePayPayments = () => new Promise((resolve) => {
  const appleMerchantId = window.config.appleypayMerchantId ?? null;
  if (window.ApplePaySession && appleMerchantId) {
    window.ApplePaySession.canMakePaymentsWithActiveCard(appleMerchantId).then((canMakeApplePayPayments) => {
      window.store.dispatch({ type: Const.purchaseDetails.updateApplePayEligibility, canMakeApplePayPayments });
      resolve(canMakeApplePayPayments);
    });
    return;
  }
  window.store.dispatch({ type: Const.purchaseDetails.updateApplePayEligibility, canMakeApplePayPayments: false });
  resolve(false);
});
